import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { verifyAdminToken, clearAdminToken, getAdminToken } from '../lib/adminAuth';

export default function ProtectedRoute({ children }) {
  const [checking, setChecking] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const validate = async () => {
      const token = getAdminToken();
      if (!token) {
        setIsValid(false);
        setChecking(false);
        return;
      }

      try {
        await verifyAdminToken();
        setIsValid(true);
      } catch (error) {
        clearAdminToken();
        setIsValid(false);
      } finally {
        setChecking(false);
      }
    };

    validate();
  }, []);

  if (checking) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <p className="text-muted-foreground">Checking admin session...</p>
      </div>
    );
  }

  if (!isValid) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
